import "./NoPage.css"
export default function NoPage() {
    return <h1 id="nopage">404</h1>;
};